import { BehaviorSubject } from 'rxjs';

export const biEventsSettingsParams$ = new BehaviorSubject({});
export const getBiEventsSettingsParams$ = () => biEventsSettingsParams$;
export const setBiEventsSettingsParams$ = (biEventsSettingsParams: object) =>
  biEventsSettingsParams$.next(biEventsSettingsParams);
